import { ProductTypeMap } from '@/api/producttypes/ProductTypeMap';
import { ProductMapping } from '@/api/productmapping';
import { IQualifier } from './IQualifier';

export abstract class Qualifier implements IQualifier {
  '_class': string;

  id?: number | null;

  validationErrors: string[] | null = null;

  abstract getDescription(productTypeMap: ProductTypeMap, productMappings: ProductMapping[]): string;

  abstract clone(): IQualifier;

  constructor(serverClass: string, id?: number | null) {
    /* eslint-disable no-underscore-dangle */
    this._class = serverClass;
    /* eslint-enable no-underscore-dangle */
    this.id = id;
  }
}

export default Qualifier;
